import { fetcher } from '@commenda/utils';
import { FileBasic } from '@commenda/types/src/file/types';
import { FileRecord } from './types';

export async function createFileRecordForCustomerRelationship(
  relationshipId: string,
  file: FileBasic,
  clerkToken?: string
): Promise<{
  success: boolean;
  data?: FileRecord;
  error?: string;
}> {
  try {
    const response = await fetcher(
      `portal/customer/relationships/${relationshipId}/file-record`,
      {
        method: 'POST',
        body: { file },
      },
      undefined,
      clerkToken
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to create file record',
      };
    }

    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}

export async function createFileRecordForSeller(
  sellerId: number,
  file: FileBasic
): Promise<{
  success: boolean;
  data?: FileRecord;
  error?: string;
}> {
  try {
    const response = await fetcher(
      `portal/sellers/${sellerId}/file-record`,
      {
        method: 'POST',
        body: { file },
      },
      undefined
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to create file record',
      };
    }

    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}
